{
  "GENERAL": {
    "CLOSE": "Fechar",
    "SHOWING_RESULTS": "A mostrar {firstIndex}-{lastIndex} de {totalCount} itens",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Procurar",
      "EMPTY_STATE": "Nenhum resultado encontrado"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "É necessário pelo menos {count}"
  }
}
